import { sendLaunchDarklyMetric } from './launchdarkly-track';

/**
 * Tracks clicks on homepage city tiles in the #cities section.
 */
(function () {
  const SECTION_SELECTOR = '#cities';
  const TILE_SELECTOR = `${SECTION_SELECTOR} a[data-cy="location-tile"]`;
  const EVENT_NAME = 'city_tile_clicked';

  function positionFor(tile) {
    const grid = tile.closest('[dusk="location-tiles"]');

    if (!grid) {
      return null;
    }

    const tiles = Array.from(
      grid.querySelectorAll('a[data-cy="location-tile"]')
    );
    const index = tiles.indexOf(tile);

    return index === -1 ? null : index + 1;
  }

  function trackCityTileClick(tile) {
    const slug = tile.dataset.citySlug || null;
    const position =
      tile.dataset.cityPosition !== undefined &&
      tile.dataset.cityPosition !== ''
        ? Number.parseInt(tile.dataset.cityPosition, 10)
        : positionFor(tile);

    sendLaunchDarklyMetric(EVENT_NAME, {
      city_slug: slug,
      position: Number.isFinite(position) ? position : null,
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (
        !window.config ||
        !window.config.launchDarkly ||
        !window.config.launchDarkly.enabled
      ) {
        return;
      }

      if (!(event.target instanceof Element)) {
        return;
      }

      const tile = event.target.closest(TILE_SELECTOR);

      if (!tile) {
        return;
      }

      trackCityTileClick(tile);
    },
    true
  );
})();
